// noinspection JSUnusedGlobalSymbols
import { createAction } from '@reduxjs/toolkit';
import { authTokenSlice } from './authToken.slice.ts';

export const { setErrorMsg, setAuthCreds, setAuthToken } = authTokenSlice.actions;
export const resetAuthToken = createAction('authToken/resetAuthToken');
